export default __webpack_public_path__ + "static/media/standard-chartered.923400df.svg";